import React from 'react';

import { GoogleOAuthProvider } from '@react-oauth/google';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'services/redux/configureStore';

import { App } from './components/App';
import { OAUTH_CLIENT_ID } from './config';
import { init } from './init';
import './index.css';

import 'dayjs/locale/ru';
dayjs.locale('ru');
dayjs.extend(relativeTime);
dayjs.extend(duration);

init();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <GoogleOAuthProvider clientId={OAUTH_CLIENT_ID}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </GoogleOAuthProvider>
);
